import { DateAutofillInput } from '@/components/ui/DateAutofillInput/DateAutofillInput';
import './PaperBookPlanBacklogCombo.css';

interface PaperBookPlanBacklogComboProps {
  value: string;
  onChange: (value: string) => void;
  isBacklog: boolean;
  onBacklogChange: (backlog: boolean) => void;
  placeholder?: string;
  className?: string;
  /** Растянуть на ширину контейнера (формы) */
  fullWidth?: boolean;
}

export function PaperBookPlanBacklogCombo({
  value,
  onChange,
  isBacklog,
  onBacklogChange,
  placeholder = 'План выхода бумажной книги',
  className = '',
  fullWidth = false,
}: PaperBookPlanBacklogComboProps) {
  const toggleBacklog = () => {
    const next = !isBacklog;
    onBacklogChange(next);
    if (next) onChange('');
  };

  return (
    <div
      className={`paper-book-plan-combo ${fullWidth ? 'paper-book-plan-combo_full' : ''} ${className}`.trim()}
    >
      <div className="paper-book-plan-combo__date">
        <DateAutofillInput
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={isBacklog}
          fullWidth
        />
      </div>
      <button
        type="button"
        className={`paper-book-plan-combo__backlog ${isBacklog ? 'paper-book-plan-combo__backlog_active' : ''}`.trim()}
        aria-pressed={isBacklog}
        onClick={toggleBacklog}
        title={isBacklog ? 'Снять бэклог' : 'Пометить как бэклог'}
      >
        Бэклог
      </button>
    </div>
  );
}
